import React from 'react'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../app/store'

export default function Items({children, arr}: any) {
  const store = useSelector((state: RootState) => state.vender)
  const type = localStorage.getItem('type')

  return (
    <>
      {(type == 'vendor' ||
        arr.some((e: any) => store.permissions && store.permissions.includes(e))) &&
        children}
    </>
  )
}
